import { LayoutContextProvider } from "./GlobalContexts/LayoutContext";
import { AuthContextProvider } from "./GlobalContexts/AuthContext";
import { CombineComponents } from "./CombineComponents";

const providers = [LayoutContextProvider, AuthContextProvider];

const AppContextProvider = CombineComponents(...providers);

export {AppContextProvider};